import Provider from './Provider';

export const PROVIDER_APP_PAYMENT_METHODS = {
  PAPER_CHECK: 'paper_checks',
  DIRECT_DEPOSIT: 'direct_deposit',
};

export default Provider;
